import * as Mui from "@material-ui/core";
import React from "react";
import { IconArrow } from "../../components/svg";

const SideNavTriggerMobile = (props) => {
  return (
    <div className="btn-menu-collapse-wrapper-mobile">
      {/* Open Close action Sidenav in smaller devices */}
      {!Mui.isWidthUp("md", props.width) ? (
        <Mui.IconButton
          onClick={() => props.toggleMobileSideNav()}
          size="small"
          className={`mr-3 svg-color-toolbar-icon btn-menu-collapse  ${props.drawerCollapse ? "open" : ""
            }`}
        >
          <IconArrow />
        </Mui.IconButton>
        // <Mui.IconButton
        //   className="mobile-menu-toggler mr-3 svg-color-toolbar-icon"
        //   onClick={() => props.toggleMobileSideNav()}
        //   size="small"
        // >
        //   <IconExpandedMenu />
        // </Mui.IconButton>
      ) : null}
    </div>
  );
};

export default Mui.withWidth()(SideNavTriggerMobile);
